import {Component, OnInit} from '@angular/core';
import {AlertService} from "../services";
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import {fuseAnimations} from "../../../@fuse/animations";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Service} from "../models/service";
import {MessageTemplate} from "../models/messageTemplate";
import {MessageTemplateService} from "../services/messageTemplate.service";
import {NotificationAccountService} from "../services/notificationAccount.service";
import {NotificationAccount} from "../models/notificationAccount";

@Component({
    templateUrl: './notificationAccountForm.component.html',
    styleUrls: ['./notificationAccountForm.component.scss'],
    animations   : fuseAnimations
})

export class NotificationAccountFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    dialogRef: any;
    availableServices: Service[];
    hide: boolean = true;
    types: any[] = [
        {
            "id": "email",
            "name": "E-mail"
        },
        {
            "id": "sms_api",
            "name": "SMS API"
        },
        {
            "id": "ultramsg_api",
            "name": "Ultramsg API"
        },
        {
            "id": "twillo",
            "name": "Twillo API"
        }
    ];

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private _matSnackBar: MatSnackBar,
        private notificationAccountService: NotificationAccountService,
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Notification accounts');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
        }

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            apiToken: [],
            password: [],
            username: [],
            port: [],
            type: [],
            senderName: [],
            senderPhone: [],
            senderEmail: [],
            url: [],
        });

        if (!this.isAddMode) {
            this.notificationAccountService.getById(this.id)
                .pipe(first())
                .subscribe((x: NotificationAccount) => {
                    this.f.name.setValue(x.name);
                    this.f.apiToken.setValue(x.apiToken);
                    this.f.password.setValue(x.password);
                    this.f.username.setValue(x.username);
                    this.f.port.setValue(x.port);
                    this.f.type.setValue(x.type);
                    this.f.senderPhone.setValue(x.senderPhone);
                    this.f.senderEmail.setValue(x.senderEmail);
                    this.f.senderName.setValue(x.senderName);
                    this.f.url.setValue(x.url);
                });
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        // this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createNotificationAccount();
        } else {
            this.updateNotificationAccount();
        }
    }

    private createNotificationAccount() {
        this.notificationAccountService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this._matSnackBar.open('Notification account added successfully', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                    this.router.navigate(['.', { relativeTo: this.route }]);
                },
                error => {
                    this.loading = false;
                    this._matSnackBar.open('Notification account creation error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                });
    }

    private updateNotificationAccount() {
        this.notificationAccountService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this._matSnackBar.open('Update successful', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this._matSnackBar.open('Notification account update error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                    this.loading = false;
                });
    }
}
